import { Helmet } from 'react-helmet-async'

const Analytics = () => {
  const googletagmanagerId = 'GTM-NCZL2X4Q'
  const scriptText = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${googletagmanagerId}');
  `

  return (
    <Helmet>
      <script
        async
        src={
          'https://www.googletagmanager.com/gtag/js?id=' + googletagmanagerId
        }
      ></script>
      <script>{scriptText}</script>
    </Helmet>
  )
}

export default Analytics
